import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ elementId, elementType }) =>
    present(
      repository
        .getElementConstraints(elementId, elementType)
        .then((constraints) => ({
          constraints,
          elementId,
          elementType,
        }))
        .catch(() => Promise.reject({ elementId, elementType })),
    );
}

export type { Interactor };

export { createInteractor };
